var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 left-side-product-box pb-0"},[(_vm.current_product.IconLocation)?_c('img',{staticClass:"border p-0",attrs:{"src":_vm.ImageMainUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }